import { yupResolver } from "@hookform/resolvers/yup/dist/yup";
import { useForm } from "react-hook-form";
import { groupValidationForm } from "../../utils/validationSchemas";
//@ts-ignore
import { FormLayout } from "@careinfo/layout";
import GroupForm from "./GroupForm";
import { tw } from "@careinfo/tailwind";

const EditGroup = (props: any) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    setValue,
    getValues,
    control,
    watch,
    clearErrors,
  } = useForm<any>({
    resolver: yupResolver(groupValidationForm),
    defaultValues: async () => {
      const data: any = await props?.refetch();
      return {
        ...data?.data,
        name: data?.data?.full_name,
        is_rest: data?.data?.is_rest,
        code: data?.data?.code,
        countries: data?.data?.countries?.map(
          (item: Record<string, string>) => ({
            label: item?.name,
            value: item?.id,
          })
        ),
      };
    },
  });
  console.log("errors", errors);
  const { handleEdit, isLoading } = props;
  return (
    <form
      onSubmit={handleSubmit(handleEdit)}
      className={tw`w-full bg-white p-0 m-0 z-1000 `}
    >
      <div className={tw` flex flex-col justify-between`}>
        <GroupForm
          errors={errors}
          register={register}
          setValue={setValue}
          isEdit={true}
          clearErrors={clearErrors}
          getValues={getValues}
          control={control}
          watch={watch}
        />

        <div className={tw`mt-4 flex justify-end`}>
          <button
            type="submit"
            className={tw`bg-primary text-white px-4 py-2 rounded`}
            disabled={isLoading}
          >
            {isLoading ? "Loading..." : "Update"}
          </button>
        </div>
      </div>
    </form>
  );
};

export default EditGroup;
